export default __webpack_public_path__ + "static/media/lion.4887d93e.png";